import React from 'react';
import mainContext from '../../../contexts/mainContext';
import { addHouseKeeperHappyWithController, deleteData, getHouseKeeperHappyWithController } from '../../../Controllers/AppManagement/houseKeeper';
import { __constants, __snackBarSeverity, __snackBarText } from '../../../constants';
import ImageTextListManager from '../common/ImageTextListManager';

export default function HouseKeeperHappyWith() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Housekeeper help"
      dialogTitle="Add new happy with"
      textLabel="Happy with"
      getData={getHouseKeeperHappyWithController}
      addData={addHouseKeeperHappyWithController}
      deleteData={deleteData}
      editTitle="Update happy with"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}